<template>
  <div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          {{ nombre }} {{ apellido }}
          <div class="c-avatar">
            <CIcon name="cil-user" />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Cuenta</strong>
      </CDropdownHeader>
      <CDropdownItem @click="mostrarCambiarUsuario">
        Cambiar nombre de usuario
      </CDropdownItem>
      <CDropdownItem @click="showCambiarPass = true">
        Cambiar contraseña
      </CDropdownItem>
      <CDropdownItem @click="cerrarSesion"> Cerrar sesión </CDropdownItem>
    </CDropdown>

    <CModal title="Modificar contraseña" :show.sync="showCambiarPass" centered>
      <CRow>
        <CCol
          ><CInput
            type="password"
            v-model="oldPass"
            label="Contraseña actual"
            @input="handleOldPass"
            placeholder="*****"
        /></CCol>
      </CRow>
      <CRow>
        <CCol
          ><CInput
            type="password"
            v-model="newPass"
            label="Nueva contraseña"
            @input="handleNewPass"
            placeholder="*****"
        /></CCol>
      </CRow>
      <CRow>
        <CCol
          ><CInput
            type="password"
            v-model="newPassRepetida"
            label="Repetir contraseña"
            @input="handleNewPassRepetida"
            placeholder="*****"
        /></CCol>
      </CRow>
      <CRow v-if="this.mensajeError != ''">
        <CCol style="color: red">{{ this.mensajeError }}</CCol>
      </CRow>
      <template #footer>
        <CButton @click="showCambiarPass = false" color="danger"
          >Cancelar</CButton
        >
        <CButton @click="cambiarPass" color="info">Guardar</CButton>
      </template>
    </CModal>

    <CModal
      title="Modificar información del usuario"
      :show.sync="showCambiarUser"
      :closeOnBackdrop="false"
      centered
    >
      <CRow>
        <CCol
          ><CInput
            type="text"
            disabled
            v-model="email"
            label="Correo"
        /></CCol>
      </CRow>
      <CRow>
        <CCol
          ><CInput
            type="text"
            :disabled="!infoCargada"
            v-model="nombre"
            label="Nombre"
            @input="handleNombre"
        /></CCol>
      </CRow>
      <CRow>
        <CCol
          ><CInput
            type="text"
            :disabled="!infoCargada"
            v-model="apellido"
            label="Apellidos"
            @input="handleApellido"
        /></CCol>
      </CRow>
      <CRow>
        <CCol
          ><CInput
            type="password"
            :disabled="!infoCargada"
            v-model="pass"
            label="Introduce la contraseña para confirmar los cambios"
            @input="handlePass"
            placeholder="*****"
        /></CCol>
      </CRow>
      <CRow v-if="this.mensajeError != ''">
        <CCol style="color: red">{{ this.mensajeError }}</CCol>
      </CRow>
      <template #footer>
        <CButton @click="showCambiarUser = false" color="danger"
          >Cancelar</CButton
        >
        <CButton :disabled="!infoCargada" @click="cambiarUser" color="info"
          >Guardar</CButton
        >
      </template>
    </CModal>

    <CModal
      title="Modificar información de usuario"
      :show.sync="mostrarInfo"
      centered
    >
      <CRow>
        <CCol v-html="mensajeResultado">{{ mensajeResultado }}</CCol>
      </CRow>
      <template #footer>
        <CButton @click="mostrarInfo = false" color="info">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { logOut } from "../utils/authUtils";
import {
  cambiarContraseña,
  cambiarUsuario,
  getNombreApellidos,
} from "../requests/utilities";
import Alerts from "../views/EjemplosPlantilla/notifications/Alerts.vue";

export default {
  components: { Alerts },
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      selectedLang: Cookies.get("lang") == "es" ? "es" : "en",
      showCambiarPass: false,
      showCambiarUser: false,
      oldPass: "",
      newPass: "",
      newPassRepetida: "",
      email: window.localStorage.getItem("email"),
      nombre: "",
      apellido: "",
      pass: "",
      infoCargada: false, //bloquea los inputs para modificar el usuario hasta que haya cargado su informacion al abrir su popup
      mensajeError: "",
      mostrarInfo: false,
      mensajeResultado: "",
    };
  },
  mounted() {
    getNombreApellidos().then((res) => {
      this.infoCargada = true;
      this.nombre = res.data.name;
      this.apellido = res.data.lastname;
    });
  },
  methods: {
    setLang(newLang) {
      Cookies.set("lang", newLang);
      window.location.reload();
    },
    cerrarSesion() {
      logOut(this.$router);
    },
    mostrarCambiarUsuario() {
      this.showCambiarUser = true;
      getNombreApellidos().then((res) => {
        this.infoCargada = true;
        this.nombre = res.data.name;
        this.apellido = res.data.lastname;
      });
    },
    getMail() {
      return window.localStorage.getItem("email");
    },
    handleOldPass(value) {
      this.oldPass = value;
    },
    handleNewPass(value) {
      this.newPass = value;
    },
    handleNewPassRepetida(value) {
      this.newPassRepetida = value;
    },
    handleEmail(value) {
      this.email = value;
    },
    handleNombre(value) {
      this.nombre = value;
    },
    handleApellido(value) {
      this.apellido = value;
    },
    handlePass(value) {
      this.pass = value;
    },
    cambiarUser() {
      if (
        this.email == "" ||
        this.nombre == "" ||
        this.apellido == "" ||
        this.pass == ""
      ) {
        this.mensajeError = "Hay campos en blanco";
        return;
      }

      this.email = window.localStorage.getItem("email");
      //console.log(this.email, this.nombre, this.apellido, this.pass);

      //cambiarUsuario
      cambiarUsuario(this.email, this.nombre, this.apellido, this.pass)
        .then((res) => {
          this.showCambiarUser = false;
          this.mostrarInfo = true;
          this.mensajeResultado =
            "Información del usuario modificada correctamente.";
          getNombreApellidos().then((res) => {
            this.infoCargada = true;
            this.nombre = res.data.name;
            this.apellido = res.data.lastname;
          });
        })
        .catch((error) => {
          this.showCambiarUser = false;
          this.mostrarInfo = true;
          this.mensajeResultado =
            "No se ha podido modificar el usuario. Causa: <b>" +
            error.response.data.error +
            "</b>";
        });
    },
    cambiarPass() {
      if (this.newPass != this.newPassRepetida) {
        this.mensajeError = "No coinciden las contraseñas";
        return;
      }

      if (
        this.newPass == "" ||
        this.newPassRepetida == "" ||
        this.oldPass == ""
      ) {
        this.mensajeError = "Hay campos en blanco";
        return;
      }

      cambiarContraseña(this.oldPass, this.newPass)
        .then((res) => {
          this.showCambiarPass = false;
          this.mostrarInfo = true;
          this.mensajeResultado = "Contraseña cambiada correctamente.";
        })
        .catch((error) => {
          this.showCambiarPass = false;
          this.mostrarInfo = true;
          this.mensajeResultado = "No se ha podido cambiar la contraseña.";
        });

      console.log(this.oldPass, this.newPass, this.newPassRepetida);
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>